import React from 'react'
import EditChalanComponent from '../OutletProduct/EditChalanComponent'

const EditChalanMain = () => {
  return (
    <EditChalanComponent/>
  )
}

export default EditChalanMain